<template>
    <div class="auth-content">
        <section class="page-content center">
            <div class="login-form">                
                <p class="label-form">Acesso Administração de Parcerias</p>
                <div class="validation-summary-valid" data-valmsg-summary="true"><ul><li style="display:none"></li>
        </ul></div>
                <label for="Email">E-mail</label>
                <v-text-field
                    style="border-radius:10px;"
                    solo
                    flat
                    v-model="login.email"
            ></v-text-field> 
            <div>              
                <label for="Password">Senha</label>
                <v-text-field
                    type="password"
                    style="border-radius:10px;"
                    v-model="login.password"
                    solo
                    flat
                    @keydown.enter="signin"
            ></v-text-field>
            </div> 
            <div class="footer-login-form">                    
                    <button class="login-button" @click="signin">Entrar</button>
                </div>
            </div>
        </section>  
        <Snackbar ref=chamaSnackbar />
    </div>
</template>

<script>
import { userKey } from '@/global'
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { baseApiUrl } from '@/global'
export default {
    components: {Snackbar},
    name: 'Auth',
    data: function() {
        return {
            login: {
                email: '',
                password: ''
            },
            token: "",
            userId: "",
            showSignup: false,
            showAlterPass: false,
            userPemission: "",
            user: {},
            emailRules: [
                v => !!v || 'E-mail é obrigatório',
                v => /.+@.+/.test(v) || 'E-mail não é válido'
            ],
            nameRules: [
                v => !!v || 'Nome é obrigatório'
            ],
            passwordRules: [
                v => !!v || 'Senha é obrigatório'
            ]         
        }
    },
    methods: {
        async signin() {
            var vm = this;
            if ((this.login.email != '') || (this.login.password != '')) {
                this.isLoading = true
                await axios.post(`${baseApiUrl}Accounts/login?include=USER`, this.login)
                .then(response => {
                    if (response.data) {
                        this.verificaAdmin(response.data.userId, response.data.id)
                    }
                })
                .catch(() => {
                    this.isLoading = false
                    vm.$refs.chamaSnackbar.snack("#EF5350","Usuário e senha inválidos. Corrija e tente novamente!","ERRO")
                })
            } else {
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("warning","Preencha os campos usuário e senha!","ATENÇÃO")
            }
        },

        async verificaAdmin(idUsuario, idToken) {
            var vm = this;
            if (idUsuario) {
                await axios.get(`${baseApiUrl}Accounts/${idUsuario}?access_token=${idToken}`)
                .then(response => {
                    if (response.data.type === "ADMIN" && response.data.active === true) {
                        localStorage.setItem('accToken', idToken)
                        this.$store.dispatch('Logar', idToken)
                        this.userObj = response.data
                        localStorage.setItem(userKey, JSON.stringify(response.data.type))
                        localStorage.setItem('userPermission', response.data.type)
                        localStorage.setItem('userName', response.data.name)
                        localStorage.setItem('user', JSON.stringify(response.data))
                        localStorage.setItem('userId', response.data.id)
                        // this.$store.dispatch('SetUser')
                        // this.$store.dispatch('Permission')
                        // this.$store.dispatch('SetUserName')
                        this.$router.push({ path: '/server-monitor' })
                        this.isLoading = false
                    } else {
                        this.isLoading = false
                        vm.$refs.chamaSnackbar.snack("warning","Usuário inativo ou sem permissão de acesso!")
                    }
                })
                .catch(() => {
                    this.isLoading = false
                    vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao verificar usuário. Tente novamente!","ERRO")
                })
            }
        },
        signup() {
            if((this.user.email != null) || (this.user.username != null) || (this.user.password != null)){
            this.$http.post('Users', this.user)
                .then(() => {
                    this.user = {}
                    this.showSignup = false
                })
                .catch(() => {           
              })
            }
            else{
               var vm = this;          
               vm.$refs.chamaSnackbar.snack("warning","Preencha os campos obrigatórios! ") 
            }         
          },
        Sair(){
            localStorage.setItem('aplicacao', null)
            this.$store.dispatch('Toggle') 
            this.$store.dispatch('Sair')
            this.$router.push({ path: '/' })
        },

        TocarSenha(){
            if((this.user.oldPassword != null) || (this.user.newPassword != null)){
            this.$http.post(`Users/change-password?access_token=${localStorage.getItem('accToken')}`, this.user)
                .then(() => {
                this.showAlterPass = false;
                var vm = this;          
                vm.$refs.chamaSnackbar.snack("success","Senha alterada com sucesso!")  
                this.user = {}
                })
                .catch(() => { 
                var vm = this;          
                vm.$refs.chamaSnackbar.snack("error","Erro na alteração da senha!")            
              })
            }
            else{
               var vm = this;          
               vm.$refs.chamaSnackbar.snack("warning","Preencha os campos obrigatórios!") 
            }
        },              
    } 	
}
</script>

<style>
    .auth-content {
        padding: 35px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .auth-modal {
        background-color: #FFF;
        width: 350px;
        padding: 35px;
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);

        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .auth-title {
        font-size: 1.2rem;
        font-weight: 100;
        margin-top: 10px;
        margin-bottom: 15px;
    }

    .auth-modal v-text-field {
        border: 1px solid #BBB;
        width: 100%;
        margin-bottom: 15px;
        padding: 3px 8px;
        outline: none;
    }

    .auth-modal a {
        margin-top: 35px;
        font-size: 1rem
    }

    .auth-modal hr {
        border: 0;
        width: 100%;
        height: 1px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }
</style>
